import React, { useState } from 'react';
import { Box, IconButton, makeStyles } from '@material-ui/core';
import { AttributeBasedFilterSimpleOptionType } from '@terragotech/gen5-config-lib/dist/AttributeBasedFilter';
import ValueIcon from '@material-ui/icons/Visibility';
import { categoryColors } from 'utils/colors';
import { TextInputTG } from 'views/components/formElements';

interface AttributeBasedTextInputProps {
  id: string;
  value: AttributeBasedFilterSimpleOptionType | undefined;
  onChange: (arrayOption: AttributeBasedFilterSimpleOptionType | undefined) => void;
  onBlur: () => void;
  keyType?: string | undefined;
  allowValue?: boolean;
}

export const AttributeBasedTextInput: React.FC<AttributeBasedTextInputProps> = ({
  id,
  value,
  onChange,
  onBlur,
  keyType,
  allowValue,
}) => {
  const classes = useStyles();
  const [tempValue, setTempValue] = useState(
    value === '$$_USER_$$' || value === '$$_VALUE_$$' ? '' : value
  );
  const isNumber = keyType === 'Int' || keyType === 'Float';

  const handleToggleValue = () => {
    if (value === '$$_VALUE_$$') {
      onChange(tempValue);
    } else {
      if (value !== '$$_USER_$$') setTempValue(value);
      onChange('$$_VALUE_$$');
    }
  };

  return (
    <Box className={classes.container}>
      {/* TODO: fix id  */}
      <TextInputTG
        id={id}
        value={value as string}
        onChange={onChange}
        onBlur={onBlur}
        style={styles.textInput}
        type={isNumber ? 'number' : 'text'}
        disabled={value === '$$_SELF_$$' || value === '$$_USER_$$' || value === '$$_VALUE_$$'}
      />
      {allowValue && (
        <IconButton
          title="Value"
          className={`${classes.button} ${value === '$$_VALUE_$$' ? classes.active : ''}`}
          component="span"
          onClick={handleToggleValue}
          onBlur={onBlur}
        >
          <ValueIcon />
        </IconButton>
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
  },
  button: {
    padding: 6,
    position: 'absolute',
    right: 0,
    color: categoryColors.defaultColor,
  },
  active: {
    color: theme.palette.primary.main,
  },
}));

const styles = {
  textInput: {
    margin: 0,
  },
};
